'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOOP = function NOOP(_) {};

// Polyfill for CustomEvent constructor.
// Modified from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
if (typeof window !== 'undefined' && typeof window.CustomEvent !== 'function') {
  var CustomEvent = function CustomEvent(eventName, params) {
    var _params$bubbles = params.bubbles,
        bubbles = _params$bubbles === undefined ? false : _params$bubbles,
        _params$cancelable = params.cancelable,
        cancelable = _params$cancelable === undefined ? false : _params$cancelable,
        _params$detail = params.detail,
        detail = _params$detail === undefined ? undefined : _params$detail;

    var event = document.createEvent('CustomEvent');

    event.initCustomEvent(eventName, bubbles, cancelable, detail);

    return event;
  };

  // add this to window object for external triggering
  window.CustomEvent = CustomEvent;
}

/**
 * Removes event listener. Complements listen function.
 * @kind function
 * @param {String}   eventName
 *                     name of custom event to be removed
 * @param {Function} eventCallback
 *                     callback to be executed on event dispatch
 * @param {Element}  eventTarget
 *                     target dispatching event - defaults to window
 */
var ignore = exports.ignore = function ignore(eventName, eventCallback) {
  var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

  // useCapture false as no optimiziation around event dispatching exists
  eventTarget.removeEventListener(eventName, eventCallback, false);
};

/**
 * Custom event listener.
 * @kind function
 * @param {String}   eventName
 *                     name of custom event to be listened to
 * @param {Function} eventCallback
 *                     callback to be executed on event dispatch
 * @param {Element}  eventTarget
 *                     target dispatching event - defaults to window
 */
var listen = exports.listen = function listen(eventName, eventCallback) {
  var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

  // useCapture false as no optimiziation around event dispatching exists
  eventTarget.addEventListener(eventName, eventCallback, false);
};

/**
 * Temporary listener removed after expiration conditions are met.
 * @param {String}   eventName
 *                     name of custom event to be triggered
 * @param {Function} expirationCallback
 *                     returns boolean as to whether listener should be removed
 * @param {Function} eventCallback
 *                     callback to be executed on event
 * @param {Element}  eventTarget
 *                     target dispatching event - defaults to window
 */
var listenUntil = exports.listenUntil = function listenUntil(eventName, expirationCallback) {
  var eventCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NOOP;
  var eventTarget = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;

  var conditionalListener = function conditionalListener(e) {
    eventCallback(e);

    if (expirationCallback(e)) {
      ignore(eventName, conditionalListener);
    }
  };

  listen(eventName, conditionalListener);
};

/**
 * Custom event trigger.
 * @kind function
 * @param {String}  eventName
 *                    name of custom event to be triggered
 * @param {Object}  eventData
 *                    payload to be returned on trigger
 * @param {Element} eventTarget
 *                    target dispatching event - defaults to window
 */
var trigger = exports.trigger = function trigger(eventName) {
  var eventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var eventTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

  var event = new window.CustomEvent(eventName, {
    bubbles: true,
    cancelable: true,
    detail: eventData
  });

  eventTarget.dispatchEvent(event);
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/@zillow/event-utils/lib/index.js
// module id = 538
// module chunks = 0